/**
 * 考试列表
 * @author jzhu
 * @date 2020-02-04
 */

import React from 'react'
import {connect} from 'dva'
import moment from 'moment'
import {framework_tool, component_tool, utils_tool} from '../../../../tool'

let {Session,isType} = utils_tool;
let {WizContainer, WizAvatarUpload, ossFileUtils} = framework_tool
let {
  WizCustomSteps,
  WizForm,
  WizRow,
  WizCol,
  WizRadio,
  WizInputNumber,
  WizIcon,
  WizCheckbox,
  WizTooltip,
  WizButton,
  Wizmessage
} = component_tool
import {modelUtils} from '@/utils'
import ExamCategorySelect from '../../exam/examCategorySelect/examCategorySelect'
import './index.less'
import {Card} from "antd";

const getParamRecord = (history) => {
  let record = {}
  if (history.location) {
    if (history.location.pathname === '/online/examTemplate/examTemplateDetailUpd') {
      if (history.location && history.location.record) {
        record = history.location.record
        Session.set('examTemplateDetailInfo', record)
      } else {
        record = Session.get('examTemplateDetailInfo') || {}
      }
    }
  }
  return record
}


class ExamTemplateDetail extends WizContainer {
  componentName = 'examTemplateDetail'

  constructor(props) {
    super(props)
    let record = getParamRecord(props.history);
    let categoryTypeName = "";
    let faceChecked = false;
    let faceDisabled = false;
    if (record) {
      let {categoryType, face, examType} = record;
      if (categoryType) {
        categoryTypeName = categoryType;
      }
      if (face === 1) {
        faceChecked = true
      }
      if (examType !== 0 || categoryType !== '普通考试') {
        faceDisabled = true;
      }
    }
    this.state = {
      faceChecked:faceChecked,
      faceDisabled:faceDisabled,
      categoryTypeName:categoryTypeName,
      faceTimesKey:new Date().getTime(),
      key: 'examTemplateDetail_' + new Date().getTime(),
      totalScore:record['totalScore'],
      record: record,
      nextStep: false
    }
    this.checks = {
      shuffle: {title: '试题顺序打乱', tips: '题序随机生成，防止考试作弊。(仅针对固定考题出卷试卷)'},
      optionRandom: {title: '选择题选项打乱', tips: '单选及多选题选项顺序随机生成，防止考试作弊。'},
      face: { title: '身份验证', tips: '考试时进行身份验证，防止考生替考。勾选后必须进行考前认证，考中认证可选' },
      examBeforeAuth: { title: '支持考前认证', tips: '身份验证勾选后，考前验证为必选项，将在进入考试后立即进行身份验证' },
      doingAuth: { title: '支持考中认证', tips: '身份验证勾选后，考中验证为可选项，设置后可在考试过程中进行身份验证' },
      autoMark: {title: '系统自动批阅'},
      showScore: {title: '批阅后允许学员查看分数', tips: '批阅后允许学员查看考试得分。'},
      showResult: {title: '批阅后允许学员查看通过状态', tips: '批阅后允许学员查看考试是否通过。'},
      showHistory: {title: '批阅后允许学员查看答卷记录', tips: '批阅后允许学员查看已提交的答卷记录。'},
      showAnswer: {title: '允许学员查看正确答案', tips: '学员查看答卷记录时，允许查看题目正确答案信息。'},
      resolve: {title: '允许学员查看答案解析', tips: '学员查看答卷记录时，允许查看题目答案解析信息。'}
    }
    this._examTemplateId = record.id
    this.resetTime=new Date().getTime()
  }


  _renderCheckRow(key, getFieldDecorator) {
    // autoMark 系统自动批阅 如果编辑时,只有为草稿状态(status = 0)才可更改
    let disabled = false
    if (key === 'autoMark' && this.state.record['status'] >= 1 && !this.copyExam) {
      disabled = true
    }
    if (key === 'face' && this.state.record['status'] > 0 && !this.copyExam){
      disabled = true
    }
    return (
      <WizRow>
        <WizCol>
          {
            getFieldDecorator(key, { initialValue: (key==='examBeforeAuth' ? true :this.state.record[key]) })(
              <WizCheckbox key={this.resetTime + key} title={this.checks[key].title}
                           defaultChecked={key==='examBeforeAuth' ? true : this.state.record[key]}
                           disabled={key==='examBeforeAuth' ? true:disabled}>
                {this.checks[key].title}
              </WizCheckbox>
            )
          }
          {this._renderCheckTips(this.checks[key].tips)}
        </WizCol>
      </WizRow>
    )
  }

  _renderCheckRowFace(key, getFieldDecorator,getFieldValue,setFieldsValue,form) {
    return (
      <WizRow key={'face_'+this.state.faceTimesKey}>
        <WizCol>
          {
            getFieldDecorator(key, { initialValue: this.state.record[key] })(
              <WizCheckbox key={this.resetTime + key} title={this.checks[key].title}
                           defaultChecked={this.state.faceChecked}
                           disabled={ this.state.faceDisabled }
              >
                {this.checks[key].title}
              </WizCheckbox>
            )
          }
          {this._renderCheckTips(this.checks[key].tips)}
        </WizCol>
      </WizRow>
    )
  }

  _renderCheckTips(tips) {
    if (tips) {
      return (
        <WizTooltip title={tips}>
          <WizIcon type='question-circle-o'/>
        </WizTooltip>
      )
    }
  }

  // 人脸认证radio
  _renderFaceAuth(form) {
    let { getFieldValue, getFieldDecorator } = form
    let { record } = this.state
    let checkFace = form.getFieldValue('face');
    let key='doingAuth';
    let disabled = (record['status'] !== 0 && record['status'] !== undefined && record['status'] !== null) && !this.copyExam // 只有发布状态,同时不是复制状态才禁用radio
    //输入框变大属性 size="large"
    return (
      checkFace ?
        (<Card bodyStyle={{paddingTop:15}}>
          {this._renderCheckRow('examBeforeAuth', getFieldDecorator)}
          <WizRow style={{marginTop: 15, marginBottom: 10}}>
            <WizCol>
              {
                getFieldDecorator(key, { initialValue: this.state.record[key] })(
                  <WizCheckbox disabled={disabled} key={this.resetTime + key} title={this.checks[key].title}
                               defaultChecked={this.state.record[key] === null || this.state.record[key] === undefined ? 0: this.state.record[key]}
                  >
                    {this.checks[key].title}
                  </WizCheckbox>
                )
              }
              {this._renderCheckTips(this.checks[key].tips)}
            </WizCol>
          </WizRow>
          <WizRow className='row-live-form-style' style={{marginTop: 15, marginBottom: 10}}>
            <WizCol span={3} className='item-form-title'>{'验证次数：'}
            </WizCol>
            <WizCol span={3} className='item-content'>
              {
                getFieldDecorator('authenticationCount', {
                  rules: [
                    {
                      validator: this._authCountValidator,_form:form
                    }],
                  initialValue: (record['authenticationCount'] === undefined || record['authenticationCount'] === null || record['authenticationCount'] <= 0) ? null : record['authenticationCount'],
                })(
                  <WizInputNumber key={'authenticationCount1'}
                                  placeholder={'请输入验证次数'}
                                  disabled={disabled} size="large" min={1} max={3} precision={0}/>
                )
              }
            </WizCol>
            <WizCol span={3} offset={1} className='item-form-title'>{'间隔时间：'}
            </WizCol>
            <WizCol span={3} className='item-content'>
              {
                getFieldDecorator('spaceTime', {
                  rules: [
                    {
                      validator: this._authTimesValidator,_form:form
                    }],
                  initialValue: (record['spaceTime'] === undefined || record['spaceTime'] === null || record['spaceTime'] <= 0) ? null : record['spaceTime'],
                })(
                  <WizInputNumber key={'spaceTime1'}
                                  placeholder={'请输入间隔时间'}
                                  disabled={disabled} size="large" min={5} max={9999} precision={0}/>
                )
              }
            </WizCol>
            <WizCol span={1}></WizCol>
            <WizCol>{'分钟 (最低为5分钟，间隔时间应小于考试时长)'}</WizCol>
          </WizRow>
        </Card>): null
    )
  }

  //认证次数校验
  _authCountValidator = (rule, value, callback) => {
    let form = rule._form;
    if (form) {
      let { getFieldValue } = form
      let doingAuth = getFieldValue('doingAuth');
      if (doingAuth!=null && doingAuth!=undefined && doingAuth===1){
        if (value===null) {
          wizNotice.warn('请输入验证次数');
          callback('请输入验证次数');
        }else if (value!=null && value<=0 ) {
          wizNotice.warn('验证次数不能小于1次');
          callback('验证次数不能小于1次');
        }
      }
    }
    callback();
  }

  //认证时间校验
  _authTimesValidator = (rule, value, callback) => {
    let form = rule._form;
    if (form) {
      let { getFieldValue } = form
      let doingAuth = getFieldValue('doingAuth');
      //考试时长
      let limitMinutes = getFieldValue('limitMinutes');
      if (doingAuth!=null && doingAuth!=undefined && doingAuth===1){
        if (limitMinutes!=null && limitMinutes>0) {
          if (value === null) {
            wizNotice.warn('请输入间隔时间');
            callback('请输入间隔时间');
          }else if (value != null && value < 5) {
            wizNotice.warn('间隔时间不能小于5分钟');
            callback('间隔时间不能小于5分钟');
          }else if (limitMinutes!=null && limitMinutes<value){
            wizNotice.warn('输入间隔时间不能超过考试时长');
            callback('输入间隔时间不能超过考试时长');
          }
        }else if (value === null || value===undefined) {
          wizNotice.warn('请先输入考试时长，之后再输入间隔时间');
          callback('请先输入考试时长，之后再输入间隔时间');
        }
      }
    }
    callback();
  }

  _columns() {

    const {record,totalScore} = this.state
    let {categoryType, categoryTypeId, scoreRule} = record
    let selects = categoryType && categoryTypeId ? [{
      label: categoryType,
      title: categoryType,
      key: categoryTypeId
    }] : []
    scoreRule = scoreRule ? scoreRule : 0
    return [
      {
        title: '考试模版名称',
        name: 'title',
        formItem: {
          maxLength: 50,
          rules: [{required: true, message: '请输入考试模版名称'}]
        }
      },
      {
        title: '考试分类',
        name: 'categoryTypeId',
        formItem: {
          type: 'diy',
          selects: selects,
          diy: ExamCategorySelect,
          rules: [{required: true, message: '请选择考试分类'}],
          onChangeRowMap: data => {
            if (data && isType(data, 'Object')) {
              let {title} = data;
              let examType = this.refs.form.getFieldValue('examType');
              if (examType!==0 || title!=='普通考试'){
                this.setState({categoryTypeName:title,faceChecked:false,faceDisabled:true,faceTimesKey:new Date().getTime()});
                this.refs.form.setFieldsValue({
                  face: 0
                });
              }else {
                this.setState({categoryTypeName:title,faceDisabled:false,faceTimesKey:new Date().getTime()});
              }
            }else {
              this.setState({categoryTypeName:'',faceChecked:false,faceDisabled:true,faceTimesKey:new Date().getTime()});
              this.refs.form.setFieldsValue({
                face: 0
              });
            }
          },
        }
      },
      {
        title: '考试类型',
        name: 'examType',
        formItem: {
          type: 'select',
          radioStyle: {
            display: 'block',
            height: '35px',
            lineHeight: '35px'
          },
          dict: [
            {code: 0, codeName: '独立考试'},
            {code: 1, codeName: '课程考试'}
          ],
          rules: [{required: true, message: '请选择考试类型'}],
          onChange: (form, value, e) => {
            let categoryTypeName = this.state.categoryTypeName;
            if (value!==0 || categoryTypeName!=='普通考试'){
              this.setState({faceChecked:false,faceDisabled:true,faceTimesKey:new Date().getTime()});
              this.refs.form.setFieldsValue({
                face: 0
              });
            }else {
              this.setState({faceDisabled:false,faceTimesKey:new Date().getTime()});
            }
          }
        }
      },
      {
        title: '试卷总分',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            return (
              <div style={{paddingLeft: 10}}>{ (totalScore && totalScore <= 0)?'-':totalScore}
                <WizTooltip title={'根据试题安排情况，自动计算试卷总分。'}>
                  <WizIcon type='question-circle-o' style={{marginLeft: 10}}/>
                </WizTooltip>
              </div>
            )
          }
        }
      },
      {
        title: '通过分数',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const {getFieldDecorator} = form
            return (
              <WizRow>
                <WizCol span={4}>
                  {
                    getFieldDecorator('passScore', {
                      rules: [{required: true, message: '请输入通过分数'}],
                      initialValue: record.passScore
                    })(
                      <WizInputNumber min={1} max={999.5}/>
                    )
                  }
                </WizCol>
                <WizCol span={1}>
                  <WizTooltip title={'请输入大于0且小于等于试卷总分的数值。'}>
                    <WizIcon type='question-circle-o' style={{marginLeft: 10}}/>
                  </WizTooltip>
                </WizCol>
              </WizRow>
            )
          }
        }
      },
      {
        title: '成绩规则',
        name: 'scoreRule',
        formItem: {
          type: 'custom',
          render: (data,form) => {
            const {getFieldDecorator} = form
            const radioStyle = {
              alignItems: 'left',
              display: 'block',
              height: '35px',
              lineHeight: '35px'
            }
            return (
              <>
                {
                  getFieldDecorator('scoreRule', {
                    rules: [{
                      required: true,
                      message: '请选择成绩规则'
                    }],
                    initialValue: scoreRule
                  })(<WizRadio.Group defaultValue={scoreRule}>
                    <WizRadio value={0} style={radioStyle}>以学员成绩的最高分计算考试通过状态</WizRadio>
                    <WizRadio value={1} style={radioStyle}>以学员成绩的平均分计算考试通过状态</WizRadio>
                  </WizRadio.Group>)
                }
              </>
            )
          }
        }
      },
      {
        title: '限制考试时长(分钟)',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const {getFieldDecorator} = form
            return (
              <WizRow>
                <WizCol span={4}>
                  {
                    getFieldDecorator('limitMinutes', {
                      rules: [
                        {required: true, message: '请输入限制考试考试时长'},
                        {pattern: /^[0-9]{1,4}$/, message: "限制最大输入4位数"}
                      ],
                      initialValue: record.limitMinutes
                    })(
                      <WizInputNumber min={1} max={9999}/>
                    )
                  }
                </WizCol>
                <WizCol span={1} className='limit-minutes-text'>分钟</WizCol>
                <WizCol span={1}>
                  <WizTooltip title={'考试用时到达后系统自动完成交卷'}>
                    <WizIcon type='question-circle-o' style={{marginLeft: 3}}/>
                  </WizTooltip>
                </WizCol>
              </WizRow>
            )
          }
        }
      },
      {
        title: '允许重复考试',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const {getFieldDecorator} = form
            return (
              <WizRow>
                <WizCol span={4}>
                  {
                    getFieldDecorator('count', {
                      rules: [
                        {required: true, message: '请输入允许重复考试次数'},
                        {pattern: /^[0-9]{1,4}$/, message: "限制最大输入4位数"}
                      ],
                      initialValue: record.count
                    })(
                      <WizInputNumber min={0} max={9999}/>
                    )
                  }
                </WizCol>
                <WizCol span={1} className='limit-minutes-text'>次</WizCol>
                <WizCol span={1}>
                  <WizTooltip title={'允许考生多次参与考试，0次则不限制次数。'}>
                    <WizIcon type='question-circle-o' style={{marginLeft: 10}}/>
                  </WizTooltip>
                </WizCol>
              </WizRow>
            )
          }
        }
      },
      {
        title: '上传封面',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const {getFieldDecorator} = form
            return (
              <>
                {getFieldDecorator('questionImg', {
                  initialValue: (record && record.img) ? [
                    {fileId:record.img}
                  ] : [],
                })(
                  <WizAvatarUpload
                    accept={'.jpg, .jpeg, .png'}
                    listType={'picture-card'}
                    aspectRatio={800 / 320}
                    beforeUpload={(file) => {
                      const isLt1M = file.size / 1024 / 1024 < 1;
                      if (!isLt1M) {
                        Wizmessage.error('图片不得超过1MB!');
                      }
                      return isLt1M;
                    }}
                  />
                )}
              </>
            )
          }
        }
      },
      {
        title: '介绍',
        name: 'intro',
        dataIndex: 'intro',
        formItem: {
          type: 'textarea',
          placeholder: '选填，请提供简介内容，方便大家了解此考试',
          maxLength: 200,
          initialValue: undefined
        },
      },
      {
        title: '防作弊限制',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const {getFieldDecorator} = form
            return (
              <>
                {this._renderCheckRow('shuffle', getFieldDecorator)}
                {this._renderCheckRow('optionRandom', getFieldDecorator)}
                {this._renderCheckRowFace('face', getFieldDecorator)}
                {this._renderFaceAuth(form)}
              </>
            )
          }
        }
      },
      {
        title: '批阅限制',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const {getFieldDecorator} = form
            return (
              <>
                {this._renderCheckRow('autoMark', getFieldDecorator)}
                {this._renderCheckRow('showScore', getFieldDecorator)}
                {this._renderCheckRow('showResult', getFieldDecorator)}
                {this._renderCheckRow('showHistory', getFieldDecorator)}
                {this._renderCheckRow('showAnswer', getFieldDecorator)}
                {this._renderCheckRow('resolve', getFieldDecorator)}
              </>
            )
          }
        }
      }
    ]
  }

  _onReset() {
    this.refs.form && this.refs.form.resetFields && this.refs.form.resetFields()
    this.resetTime = new Date().getTime()
  }

  _fitterExamValues(values) {
    let fitterValues = {}
    Object.keys(values).forEach(key => {
      let value = values[key]
      if (value !== null && value !== undefined && value !== '' && value !== 'null') {
        fitterValues[key] = value
      }
    })
    Object.keys(this.checks).forEach(key => {
      fitterValues[key] = fitterValues[key] ? 1 : 0
    })
    fitterValues.categoryTypeId = fitterValues.categoryTypeId
    /**
     * 图片参数处理
     */
    let questionImg = fitterValues['questionImg']
    if (questionImg && questionImg.length) {
      fitterValues['img'] = questionImg[0]['fileId']
      delete fitterValues['questionImg']
    }
    return fitterValues
  }

  _onSave(nextStep) {
    const {record,totalScore}  = this.state
    const {state}  = record
    let form = this.refs.form
    if (form) {
      form.validateFields((err, values) => {
        let imgFile = values.questionImg && values.questionImg.length ? values.questionImg[0] : ''
        if (!err) {
          let params = this._fitterExamValues(values)
          params.fileMimeType = imgFile.fileType
          params.fileName = imgFile.name
          params.fileSize = imgFile.size
          params.fileUri = imgFile.sysUrl
          //模版状态 有效
          params.state = state||0
          this.setState({nextStep, record: params}, () => {
            if (this._examTemplateId) {
              params.pathUrl = 'examTemplate/updateExamTemplate'
              this.doAction({
                path: 'examTemplate/updateExamTemplate',
                payload: {
                  key: 'examTemplate@update',
                  apiParams: {id: this._examTemplateId, ...params,totalScore:totalScore}
                }
              })
            } else {
              params.pathUrl = 'examTemplate/createExamTemplate'
              this.doAction({
                path: 'examTemplate/createExamTemplate',
                payload: {
                  key: 'examTemplate@create',
                  apiParams: {...params}
                }
              })
            }
          })
        }else {
          if (err){
            const {spaceTime,authenticationCount} = err;
            if (spaceTime && spaceTime.errors && spaceTime.errors instanceof Array && spaceTime.errors.length>0){
              const {message,field} = spaceTime.errors[0];
              form.setFields({
                'spaceTime': {
                  value: values['spaceTime'],
                  errors: [
                    new Error(message)
                  ]
                }
              });
            }
            if (authenticationCount && authenticationCount.errors && authenticationCount.errors instanceof Array && authenticationCount.errors.length>0){
              const {message,field} = spaceTime.errors[0];
              form.setFields({
                'authenticationCount': {
                  value: values['spaceTime'],
                  errors: [
                    new Error(message)
                  ]
                }
              });
            }
          }
        }
      })
    }
  }

  _renderFooter = () => {
    return (
      <WizRow className='form-btns col-item'>
        <WizCol span={24}>
          <WizButton title='下一步' type='primary' htmlType='submit' onClick={e => this._onSave(true)}>保存并进入下一步</WizButton>
          <WizButton title='保存' htmlType='submit' onClick={e => this._onSave(false)}>保存并返回</WizButton>
          <WizButton title='重置' onClick={e => this._onReset()}>重置</WizButton>
        </WizCol>
      </WizRow>
    )
  }

  _render() {
    let columns = this._columns()
    let formProps = {
      key: this.state.key,
      ref: 'form',
      columns,
      record: this.state.record,
      preview: null,
      footer: this._renderFooter(),
      formItemLayout: {
        labelCol: {span: 4},
        wrapperCol: {span: 15}
      }
    }
    let wizCustomStepsProps = {
      header: [
        {title: '考试信息'},
        {title: '考试章节'}
      ],
      current: 0,
      content: <WizForm {...formProps} />,
      footer: null
    }
    return <WizCustomSteps {...wizCustomStepsProps} />
  }

  propsAndStateOnChange = {
    createExamTemplate: this._createExamTemplateOnChange.bind(this),
    updateExamTemplate: this._updateExamTemplateOnChange.bind(this)
  }

  _createExamTemplateOnChange(nextProps, nextState) {
    if (nextProps.createExamTemplate.code === 1) {
      this._examTemplateId = nextProps.createExamTemplate.data
      if (this.state.nextStep) {
        this._nextPage()
      } else {
        this.jumpPage('replace', '/online/examTemplate')
      }
    }
    return true
  }

  _updateExamTemplateOnChange(nextProps, nextState) {
    if (nextProps.updateExamTemplate.code === 1) {
      if (this.state.nextStep) {
        this._nextPage()
      } else {
        this.jumpPage('replace', '/online/examTemplate')
      }
      nextState.nextStep = false
    } else {
      wizNotice.error(nextProps.updateExamTemplate.msg)
      return false;
    }
    return true
  }

  _nextPage() {
    this.jumpPage(
      'push',
      '/online/examTemplate/examTemplateChapter' + (this._examTemplateId ? 'Upd' : 'Add'),
      {...this.state.record, id: this._examTemplateId}
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const {examTemplate} = state
  const createExamTemplate = modelUtils.getModelEntity(examTemplate, 'examTemplate@create')
  const updateExamTemplate = modelUtils.getModelEntity(examTemplate, 'examTemplate@update')
  const load = modelUtils.getLoadingState(state, 'exam')
  return {
    createExamTemplate,
    updateExamTemplate,
    ...load
  }
}

export default connect(mapStateToProps)(ExamTemplateDetail)
